/*
 * @Author: louis
 * @Date: 2021-07-19 10:25:41
 * @LastEditTime: 2021-07-28 16:57:21
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \nodeplsu\src\locales\en-US.js
 */
const en_US = {
  menu_home:'Home',
  menu_news:'News',
  menu_feature:"Features",
  menu_networks:"Networks",
  menu_aboutUs:'About Us',
  menu_faq:"FAQ",

  bannner_text:'Staking service provider for Blockchain',
  bannner_text2:'Nodeplus helps institutional investors to compound their crypto assets investments through secure staking',
  banner_btn:"Contact Us",

  data_1:"Total  staking assets",
  data_2:" Total rewards for investors",
  data_3:"Continually service",
  data_4:"Hosted nodes",
  data_hours:"Hours",

  feature_1:"Customized",
  feature_1_text:"Improve business efficiency by using customised auxiliary tools of hardware wallet to achieve out-of-the-box use in minutes.",
  feature_1_text_2:"Provide customised staking solutions and exclusive nodes to help business growth.",

  feature_2:"Monitoring",
  feature_2_text:"Real-time monitoring tools to inspect the running status of block producers, anytime and anywhere.",

  feature_3:"Professional",
  feature_3_text:"Focusing on staking for more than 4 years. Deploying in multiple IDC in 12+ regions around the world, ensuring low latency, high stability, and continuous operation without downtime.",

  feature_4:"Rewards Tuning",
  feature_4_text:"The strategies tuning by blockchain specialists ensure top-level uptime and maximum rewardsperformance.",

  feature_5:"Secure",
  feature_5_text:"Based on zero trust, the professional technical solution guarantees the absolute security of the private key and avoids all potential risks.",
  feature_5_text2:"7X24 hours of monitoring and warning system, actively discovering and dealing with problems inadvance to ensure staking rewards.",

  faq_q1:"What is Nodeplus?",
  faq_a1:["With Nodeplus service, Deploying node services will be very simple and without technical teamhuman resources costs."," Nodeplus blockchain technology experts will build a safe, robust node service in multiple IDC around the world."],
  faq_q2:"What are Nodeplus Benefits?",
  faq_a2:["Based on Nodeplus services, you will customize the validator operating commission ratio, node name, and other related information. Nodeplus also offers a financial statement monthly and yearly, depending on your specific requirements. In this way, you only need to focus on community building and Dapp development without distracting node maintenance anymore."],
  faq_q3:"What is the difference between Nodeplus vs AWS/Google Cloud?",
  faq_a3:[`There are more than a hundred kinds of POS blockchain networks which use totally different client software.`," However, AWS and Google Cloud only provide the basic software operating environment without any pre-install, configuration, and blockchain network maintenance.","Based on the Linux operating system, Nodeplus builds the operating system image of the blockchain network exclusively, pre-installed client software and related dependencies for different blockchain networks, which is an entirely staking OS environment."],
  faq_q4:"How do I get started with Nodeplus?",
  faq_a4:[`Please feel free to reach out to us, we will deploy the relevant staking service for you as soon aspossible.`],
 

  ContactUs:'Contact Us',
  YourName:'Your full name',
  Email:'Email',
  Phone:"Contact number",
  message:'Message',
  aboutUs_info:"As a POS blockchain (Proof of Staking) node service provider, Nodeplus provides non-custodialstaking services for institution customers compounding their crypto assets investments. ",
  aboutUs_info2:"We focus on securing assets, maximising investment rewards and customised support.",
  send_btn:"Send",
  learn_more:"Stake Now",

  name_tip:"Please input your full name!",
  email_tip:"Please input your email",
  email_correct:"Please input correct email",
  phone_tip:"Please input your contact number!",
  leavel_message:"please input your message",

  send_success:"Submitted successfully",
  send_success_info:"We will contact you as soon as possible!",
  network_error:"Network error, please try again later~",
  ok:"ok",

  footer_navigation:"Navigation",
  footer_address:"Address",
  footer_explain:"Legal",
  footer_privacy:"Privacy policy",
  footer_termsOfUse:"Terms of use",


}    
export default en_US;